import {unwrapAPIError} from 'utils'
import {getEntitlementsBaseUrl, requestHandler} from '../HTTP'
import {HttpMethods} from '../HTTP/HTTP.types'
import {EntitlementsResponse, EntitlementsData} from 'interfaces'

const entitlementBaseUrl = getEntitlementsBaseUrl()

const getEntitlements = async (): Promise<EntitlementsData> => {
  try {
    const {data: resBody} = await requestHandler<EntitlementsResponse>({
      method: HttpMethods.GET,
      // Override axios baseUrl
      url: `${entitlementBaseUrl}/entitlements`,
    })
    return resBody.data
  } catch (error) {
    const errorValue = unwrapAPIError(error)
    return Promise.reject(errorValue)
  }
}

export const EntitlementsService = {
  getEntitlements,
}
